import { useMutation } from "@shared/lib/hooks";
import { AddRightsService } from "../services/addRights.service";

export default function useAddAdRightsMediaLink () {
    const {
        mutate: addAdRightsMediaLink,
        isLoading: isAdRightsMediaLinkLoading,
        error: addAdRightsMediaLinkError,
        isSuccess: isAddAdRightsMediaSuccess
    } = useMutation({
        mutationFn: ({
            adRightsTrackerId,
            mediaLink,
            downloadableMediaUrls
        }: {
            adRightsTrackerId: string;
            mediaLink?: string;
            downloadableMediaUrls?: string[];
        }) => AddRightsService.uploadAdRightsMediaLink(
            adRightsTrackerId, mediaLink, downloadableMediaUrls
        ),
        options: {
            skipInvalidation: true
        },
        onSuccess: (c) => {}
    });

    return {
        addAdRightsMediaLink,
        isAdRightsMediaLinkLoading,
        isAddAdRightsMediaSuccess,
        addAdRightsMediaLinkError
    };
}